import React from "react";
import BaseComponent from "../baseComponent";
import LoginComponent from "./loginComponent";
import {eventConstants} from "../../constants";
import Utility, {dispatchAction} from "../../utility";
import {connect} from "react-redux";
import userService from "../../services/user";
import {history} from "../../managers/history";

export class Login extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            email: "",
            emailError: "",
            password: "",
            passwordError: "",
        };
    }

    onCheckboxChange = () => {
        this.setState({checked: !this.state.checked});
    };

    onChangeEvent = (event) => {
        this.setState({[event.target.id]: event.target.value});
    };

    validateLoginForm = () => {
        this.setState({
            emailError: this.state?.email?.length <= 0 ? "" : "Please enter username",
            passwordError:
                this.state?.password?.length <= 0 ? "" : "Please enter password",
        });
        return Utility.validateEmail(this.state.email);
    };
    onLoginClicked = async () => {
        // if (!this.validateLoginForm()) return;
        this.props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(
            userService.loginAdmin({
                username: this.state.email,
                password: this.state.password,
            }),
        );
        this.props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err) {
            Utility.apiFailureToast("Incorrect username or password.");
            return;
        }
        Utility.apiSuccessToast("Login Successful");
        this.props.dispatchAction(eventConstants.SIGN_IN_SUCCESS, res);
        history.push("/dashboard");
    };

    render() {
        return (
            <LoginComponent
                state={this.state}
                onCheckboxChange={this.onCheckboxChange}
                onChangeEvent={this.onChangeEvent}
                onLoginClicked={this.onLoginClicked}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(Login);
